// extracted by mini-css-extract-plugin
export default {"preloaderWrapper":"PreloaderComponent_preloaderWrapper__DtUxR","loadingWrapper":"PreloaderComponent_loadingWrapper__0dVQ-","preloader":"PreloaderComponent_preloader__2GGIf"};